export { MultiDayHeader } from './MultiDayHeader';
export { MultiDayHeaderDailyNotes } from './MultiDayHeaderDailyNotes';
export { MultiDayBody } from './MultiDayBody';

// The width of the column header on small screens (mobile).
export const colHeaderWidthMobile = 64;
